import React from "react";
import "./BePartSection.scss";

const BePartSection = ({
  title = "ARCHIVE PROJECT",
  subtitle = "by funooni",
  logo,
  message = "We’re actively working on new collections — stay tuned.",
  footer = "X X X",
}) => {
  return (
    <div className="comingsoon">
      <div className="comingsoon__titleblock">
        <div>
          <h3>{title}</h3>
          <span>{subtitle}</span>
        </div>

        <div className="dots3 dots--large"></div>
      </div>

      <div className="comingsoon__center">
        <img src={logo} alt="brand logo" className="logo3" />
        <p>{message}</p>
        <div className="dots3 dots--small"></div>
      </div>

      <div className="bottom-dot">
        <div className="dot-row">
          <div className="dots3 dots--medium"></div>
        </div>

        <div className="comingsoon__footer">{footer}</div>
      </div>
    </div>
  );
};

export default BePartSection;
